export default __webpack_public_path__ + "static/media/poordog5.22b63bec.jpg";